import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { AdminGuard } from '../core/guards/admin.guard';
import { GestionnaireGuard } from '../core/guards/gestionnaire.guard';
import { FamilleGuard } from '../core/guards/famille.guard';
import { AnimateurGuard } from '../core/guards/animateur.guard';
import { PraticienGuard } from '../core/guards/praticien.guard';
import { TechnicienGuard } from '../core/guards/technicien.guard';
import { RoleGuard } from '../core/guards/role.guard';
import { ROLES } from '../core/constants/roles.constants';

export const DASHBOARD_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadComponent: () => import('../features/dashboard/dashboard.component').then(m => m.DashboardComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'horoscopes/list',
    loadComponent: () => import('../features/horoscopes/list/list.component').then(m => m.HoroscopesListComponent),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'phrases-du-jour/list',
    loadComponent: () =>
      import('../features/phrases-du-jour/list/list.component').then(
        m => m.PhrasesDuJourListComponent
      ),
    canActivate: [AuthGuard, AdminGuard],
  },
  {
    path: 'dashboard-gestionnaire',
    loadComponent: () =>
      import('../features/dashboardGestionnaire/dashboard-gestionnaire.component').then(
        m => m.DashboardGestionnaireComponent
      ),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'dashboard-famille',
    loadComponent: () =>
      import('../features/dashboardFamille/dashboardfamille.component').then(m => m.DashboardFamilleComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'dashboard-animateur',
    loadComponent: () =>
      import('../features/dashboardAnimateur/dashboard-animateur.component').then(m => m.DashboardAnimateurComponent),
    canActivate: [AuthGuard, AnimateurGuard],
  },
  {
    path: 'dashboard-externe',
    loadComponent: () =>
      import('../features/dashboardExterne/dashboard-externe.component').then(m => m.DashboardExterneComponent),
    canActivate: [AuthGuard, RoleGuard],
    data: {
      roles: [ROLES.PODOLOGUE, ROLES.COIFFEUR],
    },
  },
  {
    path: 'dashboard-praticien',
    loadComponent: () =>
      import('../features/dashboardPraticien/dashboard-praticien.component').then(m => m.DashboardPraticienComponent),
    canActivate: [AuthGuard, PraticienGuard],
  },
  {
    path: 'dashboard-technicien',
    loadComponent: () =>
      import('../features/dashboardTechnicien/dashboard-technicien.component').then(m => m.DashboardTechnicienComponent),
    canActivate: [AuthGuard, TechnicienGuard],
  },
];
